import React, { SVGProps } from 'react';

export const IconPause = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="M13 8.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v15c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-15Zm11 0a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5v15c0 .28.22.5.5.5h4a.5.5 0 0 0 .5-.5v-15Z"/></svg>;
